import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden" aria-labelledby="hero-heading">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20digital%20platform%20entrance%20with%20warm%20orange%20and%20cream%20gradient%20background%2C%20flowing%20geometric%20shapes%20representing%20connectivity%20and%20technology%2C%20soft%20ethereal%20light%20effects%2C%20clean%20futuristic%20atmosphere%2C%20no%20text%20or%20logos%2C%20professional%20corporate%20style%20digital%20art%20with%20smooth%20gradients%20and%20abstract%20network%20nodes&width=1920&height=900&seq=hero-main-91cc&orientation=landscape"
          alt="91.cc 官方平台入口背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 id="hero-heading" className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 md:mb-6 leading-tight">
          91.cc 官方平台入口与核心功能全解析
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          全面了解 91.cc 的官方入口、核心功能、使用指南及最新动态，安全便捷地访问 91.cc 平台服务
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://91.cc"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 text-base font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            访问 91.cc 官方平台
            <i className="ri-arrow-right-up-line ml-2 text-lg"></i>
          </a>
          <Link
            to="/category/guide"
            className="inline-flex items-center px-8 py-3 text-base font-medium rounded-full border border-white/40 text-white hover:bg-white/15 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            查看使用指南
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}